import { render, staticRenderFns } from "./NoticeManage.vue?vue&type=template&id=931b0d76&scoped=true"
import script from "./NoticeManage.vue?vue&type=script&lang=js"
export * from "./NoticeManage.vue?vue&type=script&lang=js"
import style0 from "./NoticeManage.vue?vue&type=style&index=0&id=931b0d76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931b0d76",
  null
  
)

export default component.exports